import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  sortIcon: {
    height: '0.625rem',
    marginLeft: theme.spacing(0.5)
  },
  ticketsTableContainer: {
    height: '100%',
    minHeight: 500,
    position: 'relative',
    boxShadow: theme.shadows[2],
    borderRadius: 4,
    backgroundColor: theme.vars.palette.background.elevation2,
    gridRow: 'span 4',
    [theme.breakpoints.down('xl')]: {
      gridColumn: 'span 2',
      gridRow: 'span 1'
    },
    [theme.breakpoints.down('md')]: {
      gridColumn: 'span 1',
      gridRow: 'span 1'
    }
  },
  noData: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: theme.vars.palette.text.secondary
  },
  ticketsTable: {
    height: '100%'
  },
  ticketsTableHeaderCell: {
    padding: '0.5rem',
    backgroundColor: theme.vars.palette.background.elevation2
  },
  ticketsTablePagination: {
    position: 'sticky',
    zIndex: 29,
    display: 'relative',
    bottom: 0,
    borderTop: `1px solid ${theme.vars.palette.border.light}`,
    borderBottom: 0, // remove weird bottom border when selecting 50 rows
    backgroundColor: theme.vars.palette.background.elevation2
  },
  tableBodyCell: {
    padding: '0.5rem'
  },
  tableLoadingDisplay: {
    '&. ag-full-width-container': { height: '100%' }
  }
}));

export default useStyles;
